export enum RouterDictionaryName {
  SignUp = 'Signup',
  LoginIn = 'Login',
  ForgotPassword = 'ForgotPassword',
  OtherProfile = 'OtherProfile',
  MyProfile = 'myProfile',
  PublicPage = 'PublicPage'
}
